/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable, Optional } from '@angular/core';
import * as SockJS from 'sockjs-client';
import * as Stomp from '@stomp/stompjs';
import { KeycloakService } from '@gh/core-auth-keycloak';
import { ENV_BASE_URL } from '@gh/config';

@Injectable()
export class WebSocketService {
  stompClient: any;
  isConnected: boolean;
  failConnected: boolean;
  socket: any;
  subscriptions$ = {};

  constructor(@Optional() private keycloak?: KeycloakService) {
    this.connect();
  }

  connect(): void {
    try {
      if (!this.socket) {
        this.socket = new SockJS(`${ ENV_BASE_URL }/webhook/ws?token=Bearer ${ this.keycloak?.token }`);
      }
      if (!this.stompClient) {
        this.stompClient = Stomp.Stomp.over(this.socket);
      }
      this.stompClient.debug = () => {};
      this.stompClient.connect({}, (
        () => this.isConnected = true
      ),                       () => {
        this.isConnected = false;
        this.failConnected = true;
        // tslint:disable-next-line:no-console
        console.log('webSocket connect failed');
        this.connect();
      });
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.log('webSocket failed ->', error);
      this.isConnected = false;
      this.failConnected = true;
    }
  }

  hasWSConnect(): boolean {
    return !!this.stompClient && this.isConnected;
  }

  on(event: string, callback: Function): void {
    if (!this.failConnected && (
      !this.stompClient || !this.isConnected
    )) {
      // tslint:disable-next-line:no-magic-numbers
      setTimeout(() => this.on(event, callback), 1000);
      return;
    }
    setTimeout(() => {
      try {
        this.subscriptions$[event] = this.stompClient.subscribe(event, callback);
      } catch (e) {
        // tslint:disable-next-line:no-console
        console.log('webSocket subscribe failed');
      }
      // tslint:disable-next-line:no-magic-numbers
    },         1000);
  }

  unsubscribe(event: string): void {
    if (this.stompClient && this.stompClient.unsubscribe && this.hasWSConnect()) {
      this.stompClient.unsubscribe(event);
    }
  }

  send(event: string, item: any): void {
    try {
      this.stompClient.send(event, {}, JSON.stringify(item));
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.log('webSocket send failed');
    }
  }
}
